import { ChangeDetectionStrategy, Component, inject, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map, Observable } from 'rxjs';
import { TrafficDeviationsStore } from '@components/traffic-deviations/stores/traffic-deviations.store';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-traffic-deviation-receipt-status-failed',
    imports: [AsyncPipe, TranslateModule],
    templateUrl: './traffic-deviation-receipt-status-failed.component.html',
    styleUrls: ['./traffic-deviation-receipt-status-failed.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrafficDeviationReceiptStatusFailedComponent implements OnInit, OnChanges {
  @Input() existingTrafficDeviationId: string;

  private readonly _deviationStore = inject(TrafficDeviationsStore);
  private readonly _id$ = new BehaviorSubject<string>(undefined);

  protected trafficDeviationStatus$: Observable<number>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['existingTrafficDeviationId']) {
      this._id$.next(this.existingTrafficDeviationId);
    }
  }

  ngOnInit(): void {
    this.trafficDeviationStatus$ = combineLatest([
      this._deviationStore.trafficDeviationReceipts$,
      this._id$
    ]).pipe(
      map(([receipts, id]) => {
        if (!receipts?.length || !id) return 0;

        const currentReceipts = receipts.filter((r) => r.trafficDeviationId === id);
        const statuses = currentReceipts.map(r => r.status);

        return Math.max(...statuses);
      }),
      distinctUntilChanged()
    );

    this._id$.next(this.existingTrafficDeviationId);
  }
}
